import type { ReactNode } from 'react';
import { CONTRACT_WRAPPER_ATTR } from './usageRecorder';

/**
 * Otoczka z identyfikatorem z kontraktu `data-testid` paczki p. Mariusza
 * (rejestr 0.11; pomiar użycia, S-22.10-02) wokół elementu, który ma już
 * NASZ identyfikator — naszych nie zmieniamy, bo czytają je scenariusze e2e.
 *
 * - w linii (`inline-flex`), żeby kliknięcie w środek otoczki trafiało
 *   w przycisk, a nie w pusty pas obok;
 * - `aria-disabled`, gdy element jest nieaktywny — sprawdzenie „nieaktywny”
 *   z kontraktu działa wtedy także na otoczce;
 * - `data-tip` — treść dymka dla sprawdzenia „podpowiedź” z kontraktu
 *   (dymek MUI rysuje się w portalu dopiero po najechaniu);
 * - rejestrator pomiaru zapisuje identyfikator otoczki zamiast naszego
 *   (`data-contract-wrapper`).
 *
 * Mapa identyfikatorów: `e2e/registry/testid-map.json` (wpis z `ours`).
 */
export function ContractTestId({
  id,
  disabled,
  tip,
  block,
  children,
}: {
  id: string;
  disabled?: boolean;
  tip?: string;
  /** Otoczka sekcji (pełna szerokość) zamiast przycisku w linii. */
  block?: boolean;
  children: ReactNode;
}) {
  const attrs: Record<string, string> = { [CONTRACT_WRAPPER_ATTR]: '' };
  if (disabled) attrs['aria-disabled'] = 'true';
  if (tip) attrs['data-tip'] = tip;
  return (
    <span data-testid={id} style={{ display: block ? 'block' : 'inline-flex' }} {...attrs}>
      {children}
    </span>
  );
}
